import axiosInstance from "../../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

const multipartHeaders = {
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
};

const buildCategoryFormData = (formData) => {
  const data = new FormData();
  if (formData.id) data.append("Id", formData.id);
  data.append("CategoryName", formData.CategoryName || "");
  data.append("CategorySlug", formData.CategorySlug || "");
  data.append("ShortDesc", formData.ShortDesc || "");
  data.append("FullDesc", formData.FullDesc || "");
  data.append("MetaTitle", formData.MetaTitle || "");
  data.append("MetaDesc", formData.MetaDesc || "");
  data.append("MetaKeywords", formData.MetaKeywords || "");
  if (formData.CategoryImage instanceof File) {
    data.append("CategoryImage", formData.CategoryImage);
  }
  return data;
};

export const addCategory = async (formData) => {
  const response = await axiosInstance.post(
    "product-category/add",
    buildCategoryFormData(formData),
    { headers: multipartHeaders }
  );
  return response.data;
};

export const updateCategory = async (formData) => {
  const response = await axiosInstance.put(
    "product-category/update",
    buildCategoryFormData(formData),
    { headers: multipartHeaders }
  );
  return response.data;
};

export const deleteCategory = async (id) => {
  return await axiosInstance.delete(`product-category/delete/${id}`, {
    headers,
  });
};

export const fetchCategoryData = async (id) => {
  const response = await axiosInstance.get(
    `product-category/GetProductCategory/${id}`,
    { headers }
  );
  return response.data.result;
};

export const getAllCategories = async () => {
  return await axiosInstance.get("product-category/GetAllProductCategories", {
    headers,
  });
};

export const fetchCategoryBySlug = async (slug) => {
  const response = await axiosInstance.get(
    `product-category/GetProductCategoryBySlug/${slug}`,
    { headers }
  );
  return response.data.result;
};